'use client';
import { useTranslations } from 'next-intl';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import { Checklist } from '@//components/Checklist';
import { TextContent } from '@//components/TextContent';
import styles from './Carfax.module.scss';

interface CarfaxProps {
  vehicle: ElasticVehicle;
}

export const Carfax: React.FC<CarfaxProps> = ({ vehicle }) => {
  const t = useTranslations('pages.item.moreInformationSection.carfax');

  return (
    <div className={styles.content}>
      <img
        src="/images/logotypes/carfax/carfax-logo-85x16.jpg"
        srcSet="/images/logotypes/carfax/carfax-logo-85x16@2x.jpg 2x"
        alt="Carfax"
        width={85}
        height={16}
        className={styles.logo}
      />
      {vehicle.inventoryStatusString?.toLowerCase() === 'order' ? (
        <TextContent textSize="md">
          <p>{t('orderVehicleDescription')}</p>
        </TextContent>
      ) : (
        <>
          <TextContent textSize="md">
            <p>{t('verifiedDescription')}</p>
          </TextContent>
          <Checklist
            items={[
              t('checklist.theftStatus'),
              t('checklist.serviceHistory'),
              t('checklist.odometer'),
              t('checklist.technicalDetails'),
            ]}
          />
        </>
      )}
    </div>
  );
};
